import React from 'react'
import { BasicStatsItem } from '../index.styles'

const Entrepreneurship = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiOGY1NTM3MzEtNjFjMi00MmJkLTk3ZjYtYzRiMDg1ZjAyMzViIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="Entrepreneurship iframe" src={link} />
    </BasicStatsItem>
  )
}

export default Entrepreneurship